import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Logo from '../../Svg/ActionButtonLogo';

import { LoadingSpinner } from '../../LoadingSpinner';

import Button from '../../Button';
import InputGroup from '../../InputGroup';
import TwoGroup from '../../TwoGroup';

import {
    ButtonGroup,
    OnSubmitValidator
} from '../../../containers/DefaultStyles/FormDetails';

import validate from './validation';

import { widgetBounce, saveWidgetFormState } from '../../../containers/Widget/actions';
import { capitalization, copyFor } from '../../../copy/copy';
import submissionErrorHandler from '../../../utils/submissionErrorHandler';

import GetUpdatesCheckbox from '../../Widget/GetUpdatesCheckbox';
import completeSubscribe from '../../../utils/widget/subscribeApi';
const ModalFormContainer = styled.form`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

const FullRow = styled.div`
    width: 100%;
    padding: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

const ModalHeading = styled.h3`
    font-family: Lato;
    margin-bottom: 1em;
    margin-top: 0.5em;
`;

const Message = styled.span`
    font-size: 14px;
    font-family: Lato;
    margin-bottom: 1em;
`;

const CloseButton = styled.div`
    z-index: 1;
    width: 14px;
    height: 26px;
    transform: rotate(45deg);
    font-family: Averta;
    font-size: 24px;
    line-height: 1.08;
    text-align: left;
    color: #5d656c;
    margin-top: -0.625em;
    cursor: pointer;
`;

const publisherMailingLists = [
    {
        ids: [3456, 2956, 2676, 3555, 3568],
        copyText: 'Receive email follow-up from Beautycounter'
    },
    {
        ids: [3441],
        copyText: 'Receive email follow-up from Feeding America'
    }
];

function getLabelText(id) {
    return (publisherMailingLists.find(el => el.ids.includes(id)) || {}).copyText;
}

function usePartnerId(id) {
    return publisherMailingLists.findIndex(el => el.ids.includes(id)) > -1;
}

class BounceForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            valid: false,
            errors: submissionErrorHandler(props.currentFormValues, validate)
        };
        this.clearSubmitErrors = this.clearSubmitErrors.bind(this);
    }

    static propTypes = {
        activeAction: PropTypes.object.isRequired,
        apiRequestData: PropTypes.object.isRequired,
        bounceFormSubmitting: PropTypes.bool,
        cachedFormData: PropTypes.object.isRequired,
        currentFormValues: PropTypes.object,
        currentPartner: PropTypes.object,
        invalid: PropTypes.bool.isRequired,
        isEU: PropTypes.bool,
        noBack: PropTypes.bool.isRequired,
        onBack: PropTypes.func,
        publisherId: PropTypes.number,
        saveWidgetFormState: PropTypes.func.isRequired,
        widgetBounce: PropTypes.func.isRequired
    };

    componentDidMount() {
        this.setState({ errors: [] });
    }

    setSubmitErrors(errors) {
        this.setState({ errors });
    }

    checkForBlurError(name) {
        const errors = submissionErrorHandler(this.props.currentFormValues, validate);
        if (errors.includes(name) && !this.state.errors.includes(name))
            this.setState({ errors: [...this.state.errors, name] });
    }

    clearSubmitErrors(fieldName) {
        if (fieldName && this.state.errors.includes(fieldName)) {
            this.setState({ errors: this.state.errors.filter(e => e !== fieldName) });
        }
    }

    render() {
        return (
            <ModalFormContainer autoComplete="on">
                <FullRow>
                    <Logo />
                    <CloseButton onClick={() => this.props.widgetBounce(false)}>
                        +
                    </CloseButton>
                </FullRow>
                <ModalHeading>
                    {copyFor('miscellaneous', 'bounceHeading', 'general', null)}
                </ModalHeading>
                <Message>
                    {copyFor('miscellaneous', 'bounceText', 'general', null)}
                </Message>
                <FullRow>
                    <Field
                        className={'fs-block'}
                        name="email"
                        onBlur={() => this.checkForBlurError('email')}
                        submissionError={this.state.errors.includes('email')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="email"
                        label={copyFor(
                            'formFields',
                            'emailAddress',
                            'email',
                            capitalization.eachWord
                        )}
                        placeholder={copyFor('placeholders', 'emailAddress', 'email')}
                    />
                </FullRow>
                <FullRow className="ie-bounce-get-updates-row">
                    <GetUpdatesCheckbox
                        style={{ paddingTop: '5px' }}
                        name="bounceGetEmailUpdates"
                        isEU={this.props.isEU}
                        defaultChecked={!this.props.isEU}
                        labelText={
                            getLabelText(this.props.apiRequestData.widgetId) ||
                            copyFor('miscellaneous', 'bounceActionNewsletter')
                        }
                    />
                </FullRow>
                <ButtonGroup
                    noBack={this.props.noBack}
                    isAddressSubmitting={this.props.bounceFormSubmitting}
                    className="ie-bounce-modal-buttons"
                >
                    <TwoGroup noBack={this.props.noBack}>
                        {!this.props.noBack && (
                            <Button
                                label={copyFor(
                                    'buttons',
                                    'back',
                                    undefined,
                                    capitalization.eachWord
                                )}
                                onClick={this.props.onBack}
                            />
                        )}
                        <OnSubmitValidator
                            onClick={e => {
                                e.preventDefault();
                                const errors = submissionErrorHandler(
                                    this.props.currentFormValues,
                                    validate
                                );
                                if (errors.length === 0 && !this.props.invalid) {
                                    this.props.saveWidgetFormState(
                                        this.props.currentFormValues.email,
                                        this.props.apiRequestData.actionId,
                                        this.props.activeAction.type,
                                        this.props.apiRequestData.widgetId,
                                        this.props.cachedFormData,
                                        this.props.route,
                                        this.props.savedResultData
                                    );
                                    const getEmailUpdates = this.props.currentFormValues
                                        .bounceGetEmailUpdates;
                                    if (
                                        getEmailUpdates ||
                                        (getEmailUpdates === undefined &&
                                            !this.props.isEU)
                                    )
                                        completeSubscribe(
                                            {
                                                email: this.props.currentFormValues.email
                                            },
                                            {
                                                partnerId: usePartnerId(this.props.apiRequestData.widgetId)
                                                    ? this.props.currentPartner.id
                                                    : undefined
                                            }
                                        );
                                } else {
                                    this.setSubmitErrors(errors);
                                }
                            }}
                        >
                            <Button
                                primary={true}
                                label={copyFor(
                                    'buttons',
                                    'submit',
                                    undefined,
                                    capitalization.eachWord
                                )}
                                type="submit"
                                className="submitButton"
                                disabled={this.props.invalid}
                            />
                        </OnSubmitValidator>
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroup>
            </ModalFormContainer>
        );
    }
}

export default compose(
    connect(
        state => {
            const activeAction = state.widget.activeAction;
            let savedResultData
            if (activeAction.type === 'voteregistration') savedResultData = state.voteRegistration;
            else if (activeAction.type === 'volunteer') savedResultData = state.volunteer;

            return {
                activeAction,
                apiRequestData: state.widget.apiRequestData,
                bounceFormSubmitting: state.widget.bounceFormSubmitting,
                cachedFormData: state.cachedFormData || {},
                currentFormValues: (state.form['bounceModal'] || {}).values,
                currentPartner: state.widget.activeAction.partner,
                isEU: (state.widget.endUserLocation || {}).isEU,
                initialValues: {
                    email: state.cachedFormData.email || ''
                },
                route: state.router.location.pathname,
                savedResultData
            };
        },
        {
            saveWidgetFormState,
            widgetBounce
        }
    ),
    reduxForm({
        form: 'bounceModal',
        destroyOnUnmount: true,
        enableReinitialize: true,
        validate
    })
)(BounceForm);
